import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {
    Elink, UpdateRoomFloorUrl
} from "../CommonComponents/Routes";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import {Modal} from "react-bootstrap";
import {GetTextColor} from "./GetTextColor";

const UpdateFloorModal = (props) => {
    const [RoomFloorId,SetRoomFloorId] = useState('');
    const RecordController = useContext(RecordsManagementContext);
    const Floor = RecordController.CompanyFloors
    const RoomFloor = props.Floor
    const For = props.For
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;
    const UpdateFloor = () => { // component is used to udpate the floor of the room
        return (
            <>
                <div className="mb-3">
                    <label className="col-form-label"><h5>Floor : </h5></label>
                    <select className="custom-select shadow"
                            style={{width: "76%", margin: "2%"}}
                            onChange={(e) =>SetRoomFloorId(parseInt(e.target.value))}
                            value={RoomFloorId || RoomFloor.FloorId}>
                        {Object.entries(Floor).map(([id, floor]) => {
                            return (
                                <option key={id} value={floor[0]}>{floor[1]}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="modal-footer mb-5">
                    <button className="btn btn-st-model-add" type="submit" onClick={()=>UpdateFloorRoom(RoomFloor)}
                            style={{background: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}>Update</button>
                </div>
            </>
        );
    }
    const handleModal = () => {
        RecordController.setCustomItemModal(false)
    }
    const UpdateFloorRoom = (room) =>{ // update the floor id and update response
        RecordController.setCustomItemModal(false);
        RecordController.SetUpdateFloor(true);
        let RoomId = room.Id, FloorId = room.FloorId;
        axios({
            method: 'post',
            url: UpdateRoomFloorUrl,
            params: {estimate_key: Elink, room_est_id: RoomId, floor_id: RoomFloorId || FloorId, for: For}
        }).then((response) =>{
            if(For === "MyHome"){
                RecordController.SetEstimateRooms(response.data.EstimateRooms);
            }
            else if(For === "Room"){
                RecordController.setRoom(response.data.EstimateRooms[RoomId]);
            }
            else if(For === "Review"){
                RecordController.SetRoomsAndInventories(response.data.EstimateRoomHash);
                RecordController.SetCompanyFloors(response.data.CompanyFloors);
            }
            SetRoomFloorId('');
            RecordController.SetUpdateFloor(false);
        });
    }

    return (
        <>
            <Modal id="mobile-link-modal" show={RecordController.CustomItemModal} onHide={() => handleModal()}>
                <Modal.Header><h4 className="custom-item-heading">Update Floor</h4>
                    <button onClick={handleModal} style={{color: "black", border: "white", height: "5%"}}>
                        <i className="fa fa-times" aria-hidden="true" style={{color: GetTextColor(CustomerInvReq.BackgroundColor), fontSize: "18px"}}></i>
                    </button>
                </Modal.Header>
                <Modal.Body><UpdateFloor/></Modal.Body>
            </Modal>
        </>
    );
}
export default UpdateFloorModal;